import { brand } from '../../theme/themePrimitives';
import ConnectFacebookModal from './modal/connect_facebook';
import { FacebookPagesObject } from '../../params/redux/form';
import { green } from '@mui/material/colors';
import ImageClass from '../../assets';
import { removeFacebookIntegrationThunk } from '../../redux/thunks/integration';
import { settingSelectedFormType } from '../../redux/slices/form';
import { useParams } from 'react-router';
import { useState } from 'react';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { refetchAllPagesThunk, removeFacebookPagesThunk } from '../../redux/thunks/form';
import { useDispatch, useSelector } from 'react-redux';

const FacebookIntegrationPagesComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams();
    const [showModal, setShowModal] = useState<boolean>(false);
    const [disconnectingPage, setDisconnectingPage] = useState<number>(0);
    const [disconnect, setDisconnect] = useState<boolean>(false);
    const [refetch, setRefetch] = useState<boolean>(false);
    const { connectedFacebook } = useSelector((state: RootState) => state.integration);
    const { formPages } = useSelector((state: RootState) => state.form);


    const handleConnectButton = async () => {
        if (connectedFacebook) {
            setDisconnect(true);
            try {
                const parsedId = id ? parseInt(id as string, 10) : 0;
                await dispatch(removeFacebookIntegrationThunk(parsedId)).unwrap();
            } catch (e) {
                //
            } finally {
                setDisconnect(false);
            }
        } else {
            setShowModal(true);
        }
    };

    const handleDisconnectButton = async (data: FacebookPagesObject) => {
        setDisconnectingPage(data.id);
        try {
            const parsedId = id ? parseInt(id as string, 10) : 0;
            await dispatch(removeFacebookPagesThunk({ client_id: parsedId, page_id: data.id })).unwrap();
        } catch (e) {
            //
        } finally {
            setDisconnectingPage(0);
        }
    };

    const RefetchAllPages = async () => {
        setRefetch(true);
        try {
            await dispatch(refetchAllPagesThunk(id ? parseInt(id as string, 10) : 0));
        } catch (e) {
            //
        } finally {
            setRefetch(false);
        }
    };

    return (<Box>
        <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="subtitle1" color="textDisabled">Manage connected Facebook pages and add new pages easily.</Typography>
        </Box>
        {<Box display="flex" flexDirection="column" gap={2}><Box minHeight="25vh" display="flex" flexDirection="column" gap={1} alignItems="center" justifyContent="start" pt={4}>
            <Box borderRadius="10px" boxSizing="border-box" border="1px solid #ededed" paddingX="15px" paddingY="30px">
                <img src={ImageClass.facebookLogo} alt="Facebook Logo" />
                <Box display="flex" gap={2} alignItems="center">
                    <Typography variant="h4" color="black" gutterBottom>Facebook Lead Ads Integration</Typography>
                    {connectedFacebook && <Box
                        px={2}
                        borderRadius={1}
                        width="max-content"
                        py="0.1rem"
                        bgcolor={green[100]}
                        color={green[400]}
                        height="max-content"
                    >
                        <Typography variant="body1" fontWeight="500">Connected</Typography>
                    </Box>}
                </Box>
                <Typography variant="subtitle1" color="black" gutterBottom>Integrate your Facebook account to manage connected profiles and add new customer accounts seamlessly</Typography>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Button variant={connectedFacebook ? 'outlined' : 'contained'} disabled={disconnect || refetch} color={connectedFacebook ? 'error' : 'primary'} sx={{ minWidth: '200px' }} onClick={handleConnectButton}>
                        {disconnect ? <CircularProgress size="15px" /> : connectedFacebook ? 'Disconnect' : 'Connect'}
                    </Button>
                    {connectedFacebook && <Box display="flex" gap={2}>
                        <Button variant="outlined" color="primary" onClick={() => dispatch(settingSelectedFormType('form'))}>View All Forms</Button>
                        <Button variant="outlined" color="primary" disabled={disconnect || refetch} onClick={RefetchAllPages}>{refetch ? <CircularProgress size="15px" /> : 'Refetch Integrations'}</Button>
                    </Box>}
                </Box>
            </Box>
        </Box>
            {connectedFacebook && <Box sx={{ py: 3 }}>
                <Typography variant="subtitle2" bgcolor={brand[50]} p={2}>
                    LINKED <strong>PAGES</strong>
                </Typography>

                {formPages.map((page, index) => (
                    <Box
                        key={index}
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            backgroundColor: '#fff',
                            border: '1px solid #ddd',
                            px: 2,
                            py: 1.5
                        }}
                    >
                        <Typography variant="subtitle2" color="textSecondary">
                            {page.page_name}
                        </Typography>
                        <Button
                            variant="outlined"
                            size="small"
                            color="secondary"
                            disabled={disconnectingPage === page.id || disconnect || refetch}
                            onClick={() => handleDisconnectButton(page)}
                        >
                            {disconnectingPage === page.id ? <CircularProgress size="20px" /> : 'Disconnect'}
                        </Button>
                    </Box>
                ))}
            </Box>}</Box>}
        {showModal && <ConnectFacebookModal open={showModal} onClose={() => setShowModal(false)} />}
    </Box>);
};

export default FacebookIntegrationPagesComponent;